import Vue from "vue";

export default {
  postLogout() {
    return Vue.axios.post("/logout", { handlerEnabled: false });
  }
};
